let inName = document.querySelector('#inName');
let errorName = document.querySelector('#emName');
let inNameKana = document.querySelector('#inNameKana');
let errorNameKana = document.querySelector('#emNameKana');
let inNameEn = document.querySelector('#inNameEn');
let errorNameEn = document.querySelector('#emNameEn');
let inTypeDog = document.querySelector('#inType-dog');
let inTypeCat = document.querySelector('#inType-cat');
let errorType = document.querySelector('#emType');
let inAppName = document.querySelector('#inAppName');
let errorAppName = document.querySelector('#emAppName');

let inEmail = document.querySelector('#inEmail');
let errorEmail = document.querySelector('#emEmail');
let inAddressPost1 = document.querySelector('#inAddress-post1');
let inAddressPost2 = document.querySelector('#inAddress-post2');
let errorAddressPost = document.querySelector('#emAddress-post');
let inAddressPref = document.querySelector('#inAddress-pref');
let errorAddressPref = document.querySelector('#emAddress-pref');
let inAddressCity = document.querySelector('#inAddress-city');
let errorAddressCity = document.querySelector('#emAddress-city');
let inTel = document.querySelector('#inTel');
let errorTel = document.querySelector('#emTel');
let inRequest = document.querySelector('#inRequest');
let errorRequest = document.querySelector('#emRequest');
let inSubmitted = document.querySelector('#inSubmitted');
let errorDna = document.querySelector('#emDna');


const submitButton = document.querySelector('#button');

submitButton.addEventListener('click', function(event) {

  if (inName.value.trim() === '') {
    inName.classList.add('invalid');
    errorName.textContent = '必須項目です。';
    scrollToElement(inName);
    event.preventDefault(); // 送信を中止
  } else {
    errorName.textContent = ''; // エラーメッセージをクリア
  }
  if (inNameKana.value.trim() === '') {
    inNameKana.classList.add('invalid');
    errorNameKana.textContent = '必須項目です。';
    scrollToElement(inNameKana);
    event.preventDefault(); // 送信を中止
  } else {
    errorNameKana.textContent = ''; // エラーメッセージをクリア
  }
  if (inNameEn.value.trim() === '') {
    inNameEn.classList.add('invalid');
    errorNameEn.textContent = '必須項目です。';
    scrollToElement(inNameEn);
    event.preventDefault(); // 送信を中止
  } else {
    errorNameEn.textContent = ''; // エラーメッセージをクリア
  }
  if (!inTypeDog.checked && !inTypeCat.checked) {
    inTypeDog.classList.add('invalid');
    inTypeCat.classList.add('invalid');
    errorType.textContent = '必須項目です。';
    scrollToElement(inTypeDog);
    event.preventDefault(); // 送信を中止
  } else {
    errorType.textContent = ''; // エラーメッセージをクリア
  }
  if (inAppName.value.trim() === '') {
    inAppName.classList.add('invalid');
    errorAppName.textContent = '必須項目です。';
    scrollToElement(inAppName);
    event.preventDefault(); // 送信を中止
  } else {
    errorAppName.textContent = ''; // エラーメッセージをクリア
  }

  if (!inEmail.value.includes('@') || inEmail.value === '') {
    inEmail.classList.add('invalid');
    errorEmail.textContent = '必須項目です。もしくはメールアドレスの形式でご入力ください。';
    scrollToElement(inEmail);
    event.preventDefault(); // 送信を中止
  } else {
    errorEmail.textContent = ''; // エラーメッセージをクリア
  }
  if (inAddressPost1.value === '' || inAddressPost2.value === '') {
    inAddressPost1.classList.add('invalid');
    inAddressPost2.classList.add('invalid');
    errorAddressPost.textContent = '必須項目です。';
    scrollToElement(inAddressPost1);
    event.preventDefault(); // 送信を中止
  } else {
    errorAddressPost.textContent = ''; // エラーメッセージをクリア
  }
  if (inAddressPref.value === '') {
    inAddressPref.classList.add('invalid');
    errorAddressPref.textContent = '必須項目です。';
    scrollToElement(inAddressPref);
    event.preventDefault(); // 送信を中止
  } else {
    errorAddressPref.textContent = ''; // エラーメッセージをクリア
  }
  if (inAddressCity.value === '') {
    inAddressCity.classList.add('invalid');
    errorAddressCity.textContent = '必須項目です。';
    scrollToElement(inAddressCity);
    event.preventDefault(); // 送信を中止
  } else {
    errorAddressCity.textContent = ''; // エラーメッセージをクリア
  }
  if (inTel.value === '') {
    inTel.classList.add('invalid');
    errorTel.textContent = '必須項目です。';
    scrollToElement(inTel);
    event.preventDefault(); // 送信を中止
  } else {
    errorTel.textContent = ''; // エラーメッセージをクリア
  }
  if (!inRequest.checked && !inSubmitted.checked) {
    inRequest.classList.add('invalid');
    inSubmitted.classList.add('invalid');
    errorDna.textContent = '必須項目です。';
    scrollToElement(inRequest);
    event.preventDefault(); // 送信を中止
  } else {
    errorDna.textContent = ''; // エラーメッセージをクリア
  }


  function scrollToElement(element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
});



